export default __webpack_public_path__ + "static/media/friends.c90439a8.svg";